export default {"src":"/_next/static/media/veeHexagon.1e7ab99c.svg","height":700,"width":600,"blurWidth":0,"blurHeight":0};